<template>
  <div>

    <!-- [ Modal form Invite Vendor ] start -->
    <sweet-modal blocking ref="inviteVendor" class="modal">
      <h1 class="modal__title">Invite Vendor</h1>

      <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="email" label="Email">
          <el-input v-model="form.email" size="mini" placeholder="Email"></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="submitForm('form')" type="primary" plain size="mini">Invite</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Invite Vendor ] end -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['inviteVendors'],
  data() {
    return {
      // Invite Vendors
      form: {
        email: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please input Email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('submit');
          // let loader = this.$loading.show();
          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          // axios
          //   .post('/api/v1/companies/create', {
          //     name: this.form.companyName,
          //     email: this.form.email,
          //     companyType: 0
          //   })
          //   .then(response => {
          //     console.log('---', response.data);
          //     this.$refs.company.close();
          //     this.notification("Success", "Create company", "success");
          //     loader.hide()
          //   })
          //   .catch(error => {
          //     console.log('An error occurred:', error);
          //     loader.hide()
          //   });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>
